/**
 * PDP variant-picker on-sale indicators (rendering layer, ADR-002).
 * Derives flags from HFCProductDomain + shopify_product.variants canonical_pricing;
 * paints data-hfc-on-sale, legacy sale classes, and size TILBUD badges only.
 * Load after product-storefront-domain.js and product-pdp-orderability-ui.js.
 */
(function (global) {
    'use strict';

    var SALE_BORDER_CLASS = '_custom-on-sale-border';
    var SALE_CONTAINER_CLASS = '_custom-on-sale-container';
    var SALE_BADGE_CLASS = '_custom-on-sale-text';
    var SALE_BADGE_HTML = '<span class="_custom-on-sale-text">TILBUD</span>';

    function get_domain() {
        return global.HFCProductDomain || null;
    }

    function get_variants() {
        var V = global.HFCProductPdpVariants;
        if (V && typeof V.getProductVariants === 'function') {
            return V.getProductVariants();
        }
        return (global.shopify_product && global.shopify_product.variants) || [];
    }

    /**
     * First picker field = color (option1). Read checked control, not hidden variant id,
     * so sale state updates immediately when Farve changes.
     */
    function resolve_selected_color_from_picker() {
        var picker = document.querySelector('variant-picker');
        if (!picker) {
            return '';
        }
        var first_field = picker.querySelector('[data-picker-field]');
        if (!first_field) {
            return '';
        }
        var checked = first_field.querySelector('input:checked');
        if (checked && checked.value) {
            return String(checked.value);
        }
        var select = first_field.querySelector('select');
        if (select && select.value) {
            return String(select.value);
        }
        return '';
    }

    function resolve_selected_color(trusted_variant) {
        var from_picker = resolve_selected_color_from_picker();
        if (from_picker) {
            return from_picker;
        }
        if (trusted_variant && trusted_variant.color) {
            return String(trusted_variant.color);
        }
        var V = global.HFCProductPdpVariants;
        if (V && typeof V.resolveSelectedVariant === 'function') {
            var resolved = V.resolveSelectedVariant();
            if (resolved && resolved.color) {
                return String(resolved.color);
            }
        }
        return '';
    }

    function derive_sale_view(trusted_variant) {
        var domain = get_domain();
        var variants = get_variants();
        var selected_color = resolve_selected_color(trusted_variant);
        if (domain && typeof domain.derivePdpOptionSaleView === 'function') {
            return domain.derivePdpOptionSaleView(variants, selected_color);
        }
        return {
            selected_color: selected_color,
            positions: { '1': {}, '2': {}, '3': {} },
            size_show_tilbud_badge: {},
        };
    }

    function option_value_on_sale(view, option_position, option_value) {
        if (!view || !option_value) {
            return false;
        }
        var bucket = view.positions[String(option_position)];
        return !!(bucket && bucket[String(option_value)]);
    }

    function is_figma_size_image_option(option_el) {
        if (!option_el || !option_el.classList.contains('pdp-figma-size-option')) {
            return false;
        }
        if (option_el.closest('.pdp-size-text-picker') || option_el.querySelector('label.pdp-size-text-option')) {
            return false;
        }
        return true;
    }

    function paint_option_element(option_el, on_sale, option_position) {
        var prev_on_sale = option_el.getAttribute('data-hfc-on-sale') === 'true';
        var is_size = String(option_position) === '3';
        var is_figma_size_image = is_size && is_figma_size_image_option(option_el);
        var use_sale_border = on_sale && !is_figma_size_image;
        var has_border = option_el.classList.contains(SALE_BORDER_CLASS);
        var badge = is_size ? option_el.querySelector('.' + SALE_BADGE_CLASS) : null;
        var has_badge = !!badge;

        if (prev_on_sale === on_sale && has_border === use_sale_border && (!is_size || has_badge === on_sale)) {
            return;
        }

        option_el.setAttribute('data-hfc-on-sale', on_sale ? 'true' : 'false');
        option_el.classList.toggle(SALE_BORDER_CLASS, use_sale_border);

        if (!is_size) {
            return;
        }

        option_el.classList.toggle(SALE_CONTAINER_CLASS, on_sale);
        if (on_sale) {
            if (!badge) {
                option_el.insertAdjacentHTML('beforeend', SALE_BADGE_HTML);
            }
            return;
        }
        if (badge) {
            badge.remove();
        }
    }

    function apply_sale_view_to_dom(view) {
        document.querySelectorAll('.variant-picker__option[data-option-position][data-value]').forEach(function (option_el) {
            var option_position = option_el.getAttribute('data-option-position');
            var option_value = option_el.getAttribute('data-value');
            var on_sale = option_value_on_sale(view, option_position, option_value);
            paint_option_element(option_el, on_sale, option_position);
        });
    }

    function apply_variant_option_sale_to_dom(trusted_variant) {
        if (!document.querySelector('.variant-picker__option[data-option-position]')) {
            return;
        }
        apply_sale_view_to_dom(derive_sale_view(trusted_variant));
    }

    global.HFCProductPdpVariantSaleUi = {
        applyVariantOptionSaleToDom: apply_variant_option_sale_to_dom,
        deriveSaleView: derive_sale_view,
        resolveSelectedColorFromPicker: resolve_selected_color_from_picker,
    };
})(typeof window !== 'undefined' ? window : this);
